import React , {Component} from "react";
import {  Formik, Form, Field } from 'formik';
import axios from 'axios';
import { MenuItem, LinearProgress, Typography, Grid, Breadcrumbs, Fab,  Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as yup from 'yup';
import {Link, useParams} from 'react-router-dom';
import { styled } from "@mui/material/styles";
import MuiTextField from '@mui/material/TextField';
import { TextField } from 'formik-mui';

import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { baseUrl } from '../../components/shared/baseUrl';
import { mongoUrl } from '../../components/shared/mongoUrl';
import CreatableSelect from 'react-select/creatable';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import { convertFromRaw } from 'draft-js';
import LazyCKEditor from "../../components/shared/LazyCKEditor.jsx";
import withRouterCompat from '../../actions/routerWrapper.jsx';

 
function Createmod() {
  return (
    <LazyCKEditor
      data="<p>Start writing here...</p>"
      onChange={(event, editor) => {
        console.log(editor.getData());
      }}
    />
  );
}

const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
  });
const standard = [
    {
        value: 'VI',
        label: 'VI'
    },
    {
        value: 'VII',
        label: 'VII'
    },
    {
        value: 'VIII',
        label: 'VIII'
    },
    {
        value: 'IX',
        label: 'IX'
    },
    {
        value: 'X',
        label: 'X'
    },
    {
        value: 'XI',
        label: 'XI'
    },
    {
        value: 'XII',
        label: 'XII'
    }

]
const levelmod = [
    {
        value: '1',
        label: '1(Demonstrated)'
    },
    {
        value: '2',
        label: '2(Structured)'
    },
    {
        value: '3',
        label: '3(Guided)'
    },
    {
        value: '4',
        label: '4(Self-Directed)'
    }

]

const subject = [
    {
        value: 'Physics',
        label: 'Physics'
    },
    {
        value: 'Chemistry',
        label: 'Chemistry'
    },
    {
        value: 'Biology',
        label: 'Biology'
    },
    {
        value: 'Mathematics',
        label: 'Mathematics'
    }

]
const previewStyle = {
    maxHeight: "200px",
    maxWidth: "200px"
  }

  const custom_config = {
    extraPlugins: [ MyCustomUploadAdapterPlugin ],
    
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'blockQuote',
        'insertTable',
        '|',
        'imageUpload',
        'undo',
        'MathType',
        'SpecialCharacters',
        'SpecialCharactersMathematical',
        'redo',
        'Subscript', 
        'Superscript',            
      ]
    }
    ,
    table: {
      contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
    }
  }

        //////Code for ckeditor
        function MyCustomUploadAdapterPlugin(editor){
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
              return new MyUploadAdapter(loader)
            }
          }
      
          class MyUploadAdapter {
            constructor(props) {
                // CKEditor 5's FileLoader instance.
              this.loader = props;
              // URL where to send files.
              this.url = `http://localhost:5000/fileupload/files`;
            }
        
            // Starts the upload process.
            upload() {
              return this.loader.file
                  .then( file => new Promise( ( resolve, reject ) => {
      
                      const toBase64 = file => new Promise((resolve, reject) => {
                          const reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = () => resolve(reader.result);
                          reader.onerror = error => reject(error);
                      });
                      
                      return toBase64(file).then(cFile=>{
                        console.log(file)
                        const data=new FormData();
                        data.append('file', file)   
                        var filename = '';
                      axios.post(`http://localhost:5000/fileupload/files`, data)
                              .then((response) => {
                                  console.log(response.data.file.filename)
                                  filename = response.data.file.filename;
                                  resolve({ 
                                    default: `http://localhost:5000/fileupload/files/${filename}` 
                                  })
                              })
                              .catch((error)=>{
                                  reject(`Couldn't upload file: ${ file.name }.`)
                                console.log(error);
                                });
                              })
                      
                  } ) );
          }
        
        }
      

  const validationSchema = yup.object().shape({
  
    title: yup
      .string()
      .min(6, "Title is too short ")
      .required('Please enter an appropriate title'),
  
    language: yup
        .string()
        .required('Please enter the language'),
    
    
    description: yup
        .string()
        .min(2, "Too Short")
        .max(100, "Too Long!")
        .required('Please enter an appropriate description'),
  
    level:yup
      .string().required('Please enter the level of module'),

    subject:yup
      .string().required('Please enter the subject of module'),

    std:yup
      .string().required('Please enter the standard/class'),

  
     
  })


class EditForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            edit:false,
            file:'',
            simfile:'',
            imagefile:'',
            backfile:'',
            matfile:'',
            methodfile:'',
            analysisfile:'',
            url: '',
            imageurl:'',
            backurl:'',
            maturl:'',
            methodurl:'',
            analysisurl:'',
            youtube:'',
            backGroundImage:'',
            backGroundYou:'',
            materialImage:'',
            materialYou:'',
            methodImage:'',
            methodYou:'',
            analysisImage:'',
            analysisYou:'',
            uploadSuccess:false,
            uploadImageSuccess:false,
            uploadSimSuccess:false,
            id:'',
            title: '',
            language: '',
            topic: [],
            description: '',
            level: '',
            subject: '',
            std: '',
            modimage: '',
            simulation:'',
            simulation_name:'',
            intro_image:'',
            intro:EditorState.createEmpty(),
            backGround:EditorState.createEmpty(),
            task:EditorState.createEmpty(),
            material:EditorState.createEmpty(),
            method:EditorState.createEmpty(),
            analysis:EditorState.createEmpty(),
            isLoading:true,
            module:[],
            currentModule:'',
            errorIntro:'',
            errorTopic:'',
            errorBack:'',
            errorTask:'',
            errorMaterial:'',
            errorMethod:'',
            errorAnalysis:'',
            clas:'',
            expanded:false

        };

        this.handleUploadClick = this.handleUploadClick.bind(this);
        this.handleSimUploadClick = this.handleSimUploadClick.bind(this);
        this.handleImageUploadClick = this.handleImageUploadClick.bind(this);
        this.handleBackUploadClick = this.handleBackUploadClick.bind(this);
        this.handleMaterialUploadClick = this.handleMaterialUploadClick.bind(this);
        this.handleMethodUploadClick = this.handleMethodUploadClick.bind(this);
        this.handleAnalysisUploadClick = this.handleAnalysisUploadClick.bind(this);
        this.cancelbutton = this.cancelbutton.bind(this);
        this.cancelSimbutton = this.cancelSimbutton.bind(this);
        this.cancelImagebutton = this.cancelImagebutton.bind(this);
        this.cancelBackGroundbutton = this.cancelBackGroundbutton.bind(this);
        this.cancelMaterialbutton = this.cancelMaterialbutton.bind(this);
        this.cancelMethodbutton = this.cancelMethodbutton.bind(this);
        this.cancelAnalysisbutton = this.cancelAnalysisbutton.bind(this);
        this.uploadbutton = this.uploadbutton.bind(this);
        this.uploadsimbutton = this.uploadsimbutton.bind(this);
        this.uploadimagebutton = this.uploadimagebutton.bind(this);
        this.uploadimageBackbutton = this.uploadimageBackbutton.bind(this);
        this.uploadimageMaterialbutton = this.uploadimageMaterialbutton.bind(this);
        this.uploadimageMethodbutton = this.uploadimageMethodbutton.bind(this);
        this.uploadimageAnalysisbutton = this.uploadimageAnalysisbutton.bind(this);
        this.handlevideo=this.handlevideo.bind(this);
        this.handleBackvideo=this.handleBackvideo.bind(this);
        this.handleMaterialvideo=this.handleMaterialvideo.bind(this);
        this.handleMethodvideo=this.handleMethodvideo.bind(this);
        this.handleAnalysisvideo=this.handleAnalysisvideo.bind(this);        
        this.onenable=this.onenable.bind(this);
        this.editbutton=this.editbutton.bind(this);
        this.htmlPage=this.htmlPage.bind(this);
        this.validateTopic=this.validateTopic.bind(this);
        this.handlelevelChange=this.handlelevelChange.bind(this);
        this.validateAnalysis=this.validateAnalysis.bind(this);
        this.handleAnalysisChange=this.handleAnalysisChange.bind(this);
        this.validateMethod=this.validateMethod.bind(this);
        this.handleMethodChange=this.handleMethodChange.bind(this);
        this.validateMaterial=this.validateMaterial.bind(this);
        this.handleMaterialChange=this.handleMaterialChange.bind(this);
        this.validateTask=this.validateTask.bind(this);
        this.handleTaskChange=this.handleTaskChange.bind(this);
        this.validateSimName=this.validateSimName.bind(this);
        this.handleSimNameChange=this.handleSimNameChange.bind(this);
        this.handleChange=this.handleChange.bind(this);
        this.onEditorStateChange=this.onEditorStateChange.bind(this);
        this.uploadImageCallBack=this.uploadImageCallBack.bind(this);
        this.onEditorBackGroundStateChange=this.onEditorBackGroundStateChange.bind(this);
        this.onEditorTaskStateChange=this.onEditorTaskStateChange.bind(this);
        this.onEditorMaterialStateChange=this.onEditorMaterialStateChange.bind(this);
        this.onEditorMethodStateChange=this.onEditorMethodStateChange.bind(this);
        this.onEditorAnalysisStateChange=this.onEditorAnalysisStateChange.bind(this);

    }
 
componentDidMount = () =>{
    const id = this.modId;

        axios.get(`${baseUrl}modules/${id}`)
        .then((response) => {
            console.log(response.data)
            if(typeof response.data.intro!=='undefined'){
                this.setState({
                    intro:response.data.intro
                })
                
                }
                if(typeof response.data.backGround!=='undefined'){
                    this.setState({
                        backGround:response.data.backGround
                    })
                    
                    }
                if(typeof response.data.task!=='undefined'){
                        this.setState({
                            task:response.data.task
                        })
                        
                    }
                    if(typeof response.data.material!=='undefined'){
                        this.setState({
                            material:response.data.material
                        })
                        
                    }
                    if(typeof response.data.method!=='undefined'){
                        this.setState({
                            method:response.data.method
                        })
                        
                    }
                    if(typeof response.data.analysis!=='undefined'){
                        this.setState({
                            analysis:response.data.analysis
                        })
                        
                    }
            this.setState({
                currentModule:response.data,
                id:response.data._id,
                title:response.data.name,
                youtube:response.data.youtube,
                title: response.data.name,
                language: response.data.language,
                topic: response.data.topic,
                description:response.data.description,
                level: response.data.level,
                subject:response.data.subject,
                std: response.data.std,
                modimage:response.data.image,
                simulation_name:response.data.simulation_name,
                simulation:response.data.simulation,
                intro_image:response.data.intro_image,
                backGroundYou:response.data.backGroundYou,
                backGroundImage:response.data.backGroundImage,
                materialYou:response.data.materialYou,
                materialImage:response.data.materialImage,
                methodYou:response.data.methodYou,
                methodImage:response.data.methodImage,
                analysisYou:response.data.analysisYou,
                analysisImage:response.data.analysisImage,

            })
            
            axios.get(`${baseUrl}modules`)
            .then((response) => {
                var topicData=[];
                Array.from(response.data).map((item)=>
                {
                         console.log(typeof item.topic)
                         item.topic.map(elem =>{
                             if(typeof elem.label !=="undefined"){
                             topicData.push({
                                 label:elem.label,
                                 value:elem.value
                             })
                             }
                         })
                     
                }) 
                this.setState({
                    module:topicData,
                  })
                if(typeof this.props.params.classId!=='undefined'){
                axios.get(`${baseUrl}class/${this.props.params.classId}`)
                .then((response) => {
                
                this.setState({
                    clas: response.data,
                    isLoading:!this.state.isLoading
                })

                })
                .catch((error)=>{
                console.log(error);
                });
            }
            else{
                this.setState({
                    isLoading:!this.state.isLoading
                })
            }
                
            })

        })
        .catch((error)=>{
        console.log(error);
        });

}    

handleAccordionChange = (panel) => (event, isExpanded) => {
    console.log(panel)
    if(isExpanded){
        this.setState({
            expanded:panel
        })
    }else{
        this.setState({
            expanded:false
        }) 
    }
  };
  
handleChange = (newValue, actionMeta) => {
    console.group('Value Changed');
    this.setState({
        topic:newValue
    })
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };
validateTopic(value) {
    console.log(this.state.topic)
    let error;
    if(this.state.topic ==''){
          error = 'Please enter appropriate topic'
       }
    return error;
}

validateAnalysis(value) {
    let error;
    if(this.state.analysis ==''){
          error = 'Please enter analysis for the module'
       }
    return error;
  }

  handleAnalysisChange(event){
    this.setState({
        analysis:event.target.value,
      })
}

validateMethod(value) {
    let error;
    //console.log(value);
    if(this.state.method ==''){
          error = 'Please enter method for the module'
       }
    return error;
  }

  handleMethodChange(event){
    this.setState({
        method:event.target.value,
      })
}

validateMaterial(value) {
    let error;
    if(this.state.material ==''){
          error = 'Please enter material for the module'
       }
    return error;
  }

  handleMaterialChange(event){
    this.setState({
        material:event.target.value,
      })
}

validateTask(value) {
    let error;
    if(this.state.task ==''){
          error = 'Please enter task for the module'
       }
    return error;
  }

  handleTaskChange(event){
    this.setState({
        task:event.target.value,
      })
}

validateSimName(value) {
    let error;
    if(this.state.simulation_name ==''){
          error = 'Please enter simulation name'
       }
    return error;
  }

  handleSimNameChange(event){
    this.setState({
        simulation_name:event.target.value,
      })
}


uploadbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.file)   
    //let url = "http://localhost:5000/imageUpload";
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            modimage:response.data.file.filename,
            uploadSuccess:!this.state.uploadSuccess,
          })
        console.log(response)
    })
    .catch(errors => console.log(errors));

}

uploadimagebutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.imagefile)   
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            intro_image:response.data.file.filename,
            uploadImageSuccess:!this.state.uploadImageSuccess,
          })
        console.log(response.data.file.filename)
    })
    .catch(errors => console.log(errors));

}

uploadimageBackbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.backfile)   
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            backGroundImage:response.data.file.filename,
            uploadImageSuccess:!this.state.uploadImageSuccess,
          })
        console.log(response.data.file.filename)
    })
    .catch(errors => console.log(errors));

}

uploadimageMaterialbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.matfile)   
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            materialImage:response.data.file.filename,
            uploadImageSuccess:!this.state.uploadImageSuccess,
          })
        console.log(response.data.file.filename)
    })
    .catch(errors => console.log(errors));

}

uploadimageMethodbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.methodfile)   
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            methodImage:response.data.file.filename,
            uploadImageSuccess:!this.state.uploadImageSuccess,
          })
        console.log(response.data.file.filename)
    })
    .catch(errors => console.log(errors));

}

uploadimageAnalysisbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.analysisfile)   
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            analysisImage:response.data.file.filename,
            uploadImageSuccess:!this.state.uploadImageSuccess,
          })
        console.log(response.data.file.filename)
    })
    .catch(errors => console.log(errors));

}

////function to change level
handlelevelChange(event){
    this.setState({level: event.target.value})
  }

  cancelbutton() {
    this.setState({
      file:'',
      url:''
    });
  }
  cancelSimbutton() {
    this.setState({
      simfile:'',
    });
  }
  cancelImagebutton() {
    this.setState({
      imagefile:'',
      imageurl:''
    });
  }
  cancelBackGroundbutton() {
    this.setState({
      backfile:'',
      backurl:''
    });
  }
  cancelMaterialbutton() {
    this.setState({
      matfile:'',
      maturl:''
    });
  }
  cancelMethodbutton() {
    this.setState({
      methodfile:'',
      methodurl:''
    });
  }
  cancelAnalysisbutton() {
    this.setState({
      analysisfile:'',
      analysisurl:''
    });
  }

uploadsimbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.simfile)   
    let url = "http://localhost:5000/fileupload/files";

    axios.post(url, data)
    .then(response => {
        this.setState({
            simulation:response.data.file.filename,
            uploadSimSuccess:!this.state.uploadSimSuccess,
          })

        console.log(response.data.file.filename)

    })
    .catch(errors => console.log(errors));

}

 handleUploadClick(event){
    
    let reader = new FileReader();
    let file = event.target.files[0];
    this.setState({
        file: event.target.files[0],
    })
    var url = reader.readAsDataURL(file)
                
    reader.onloadend = () => {
    this.setState({
        url: reader.result,
        })
    }
      if(this.state.uploadSuccess===true){
        this.setState({
            uploadSuccess:!this.state.uploadSuccess
          }) 
      }
      
    };

    handleSimUploadClick(event){
        this.setState({
            simfile: event.target.files[0],

          })
          
          if(this.state.uploadSimSuccess===true){
            this.setState({
                uploadSimSuccess:!this.state.uploadSimSuccess
              }) 
        }
    };

    handleImageUploadClick(event){
        // console.log('Image upload started')
        this.setState({
            imagefile: event.target.files[0],
            imageurl: URL.createObjectURL(event.target.files[0])
          })
         
          
          if(this.state.uploadImageSuccess===true){
            this.setState({
                uploadImageSuccess:!this.state.uploadImageSuccess
              }) 
          }
        }; 
        handleBackUploadClick(event){
            // console.log('Image upload started')
            this.setState({
                backfile: event.target.files[0],
                backurl: URL.createObjectURL(event.target.files[0])
              })
             
              
              if(this.state.uploadImageSuccess===true){
                this.setState({
                    uploadImageSuccess:!this.state.uploadImageSuccess
                  }) 
            }
        };
        handleMaterialUploadClick(event){
            // console.log('Image upload started')
            this.setState({
                matfile: event.target.files[0],
                maturl: URL.createObjectURL(event.target.files[0])
              })
              
              
              if(this.state.uploadImageSuccess===true){
                this.setState({
                    uploadImageSuccess:!this.state.uploadImageSuccess
                }) 
            }
        }; 
        handleMethodUploadClick(event){
            // console.log('Image upload started')
            this.setState({
                methodfile: event.target.files[0],
                methodurl: URL.createObjectURL(event.target.files[0])
              })
              
              if(this.state.uploadImageSuccess===true){
                this.setState({
                    uploadImageSuccess:!this.state.uploadImageSuccess
                }) 
            }
        };
        handleAnalysisUploadClick(event){
            this.setState({
                analysisfile: event.target.files[0],
                analysisurl: URL.createObjectURL(event.target.files[0])
              })
              
              if(this.state.uploadImageSuccess===true){
                this.setState({
                    uploadImageSuccess:!this.state.uploadImageSuccess
                }) 
            }
        };    
    
    handlevideo = (event) => {
        if(event.target.value){
        this.setState({
            youtube: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))
             
          })
        }else{
            this.setState({youtube: ''})

        }
        };

    handleBackvideo = (event) => {
            if(event.target.value){
            this.setState({
                backGroundYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))
            
              })
        }
        else
        {
            this.setState({backGroundYou: ''})
    
        }
    };
    handleMaterialvideo = (event) => {
                if(event.target.value){
                this.setState({
                    materialYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))
                
                  })
                }else{
                    this.setState({materialYou: ''})
        
                }
                };

    handleMethodvideo = (event) => {
        if(event.target.value){
        this.setState({
            methodYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))      
            
        })
        }else{
            this.setState({methodYou: ''})
    
        }
        };
    
    handleAnalysisvideo = (event) => {
            if(event.target.value){
            this.setState({
                analysisYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))      
                
            })
            }else{
                this.setState({analysisYou: ''})
        
            }
        };
    onenable(){
        this.setState({expdisable:!this.state.expdisable})

    }    
    editbutton(){
        this.setState({edit: !this.state.edit})
      
      }
      htmlPage(){
        if(typeof window.GGBApplet !== 'undefined'){
            console.log(this.state.simulation)

        var ggbApp = new window.GGBApplet({filename:`http://localhost:5000/fileupload/files/${this.state.simulation}`, "width": 1200, "height": 800, "showFullscreenButton":true }, true);
        }
        const apploader = () =>{

            // window.addEventListener('load', function() {

                //  if(this.state.isLoading != true){

                    console.log('Loading simulation')
                    ggbApp.inject('ggb-elem');
                // }
                
             //})
           
        }
                
        return(
        this.myref!==null?
          <div id="header" className="row">
            <meta name='viewport' content="width=device-width,initial-scale=1"></meta>
            <meta charSet="utf-8"/>
            <div id="ggb-elem">
            </div>          
            {apploader()}
          </div>:null
        );

      }

      onEditorStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            intro:editor.getData()
        })
      };

      onEditorBackGroundStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            backGround:editor.getData()
        })
      };
      onEditorTaskStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            task:editor.getData()
        })
      };
      onEditorMaterialStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            material:editor.getData()
        })
      };
      onEditorMethodStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            method:editor.getData()
        })
      };
      onEditorAnalysisStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            analysis:editor.getData()
        })
      };

    uploadImageCallBack = (file) =>{
        
        // We need to return a promise with the image src
        // the img src we will use here will be what's needed
        // to preview it in the browser. This will be different than what
        // we will see in the index.md file we generate.
        return new Promise(
          (resolve, reject) => {
          const data=new FormData();
          data.append('file', file)   
          var filename = '';
        axios.post(`http://localhost:5000/fileupload/files`, data)
                .then((response) => {
                    console.log(response.data.file.filename)
                    filename = response.data.file.filename;
                    resolve({ 
                      data: { link: `http://localhost:5000/fileupload/files/${filename}` } 
                    })
         })
           
          }
        );
      }

    render(){
        console.log(this.state.modimage);
        const { classes } = this.props;


      return (
       
        
           <GridContainer>
               <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
               {typeof this.props.params.classId!=='undefined'?
                <Link color="inherit" to="/admin/dashboard">
                    Dashboard
                </Link>
               :<Link color="inherit" to="/admin/home">
                        Home
                </Link>}
                {typeof this.props.params.classId!=='undefined'?
                <Link color="inherit" to={`/admin/dashboard/viewclass/${this.props.params.classId}`}> 
                    <Typography color="textPrimary">{this.state.clas.title}</Typography>
                </Link>:null}
                {typeof this.props.params.classId!=='undefined'?
                <Link color="inherit" to={`/admin/dashboard/createsession/${this.props.params.classId}`}> 
                <Typography color="textPrimary">Create new Session</Typography>
              </Link>:null}
              {typeof this.props.params.classId!=='undefined'?
                <Link color="inherit" to={`/admin/dashboard/modulelibrary/${this.props.params.classId}`}> 
                    <Typography color="textPrimary">Select from Library</Typography>
                </Link>
                :null}
                {typeof this.props.params.classId!=='undefined'?
                    <Link color="inherit" to={`/admin/home/viewmodule/${this.state.id}/${this.props.params.classId}`}>
                        {this.state.title}
                    </Link>:
                    <Link color="inherit" to={`/admin/home/viewmodule/${this.state.id}`}>
                        {this.state.title}
                    </Link>
                    }
                <Typography color="textPrimary">Edit Module</Typography>
                </Breadcrumbs>
                {this.state.isLoading!==true ?
                <Formik
                    initialValues={{
                    title: this.state.title,
                    language: this.state.language,
                    description: this.state.description,
                    level: this.state.level,
                    subject:this.state.subject,
                    std: this.state.std,
                    modimage:this.state.modimage,
                    youtube:this.state.youtube,
                    simulation_name:this.state.simulation_name,
                    simulation:this.state.simulation,
                    intro_image:this.state.intro_image,
                    intro:'',
                    backGround:'',
                    backGroundYou:this.state.backGroundYou,
                    backGroundImage:this.state.backGroundImage,
                    task:'',
                    material:'',
                    materialYou:this.state.materialYou,
                    materialImage:this.state.materialImage,
                    method:'',
                    methodYou:this.state.methodYou,
                    methodImage:this.state.methodImage,
                    analysis:'',
                    analysisYou:this.state.analysisYou,
                    analysisImage:this.state.analysisImage

                    }}

                    validationSchema={validationSchema}

                    onSubmit={(values, {setSubmitting}) => {
                    setTimeout(() => {
                        setSubmitting(false);
                        this.setState({edit: !this.state.edit})
                        

                        var empty = true;

                        if(this.state.topic.length==0){
                            this.setState({
                                errorTopic:'Please enter related topics for the module'
                            })
                        }
                        else{

                            this.setState({
                                errorTopic:''
                            }) 
    
                            var emptyIntro=true;
                            const Introdata = this.state.intro;
                            
                        
                            if(Introdata !== ''){
                                emptyIntro=false
                            }
                            if(emptyIntro==true){
                                this.setState({
                                    errorIntro:'Please enter Introduction for the module'
                                })
                            }
                            else{
                                this.setState({
                                    errorIntro:''
                                })
                            }
    
                            const Backdata = this.state.backGround;
                            var emptyBack=true;
                            
                        
                            if(Backdata !== ''){
                                emptyBack=false
                            }
                            if(emptyBack==true){
                                this.setState({
                                    errorBack:'Please enter BackGround for the module'
                                })
                            }
                            else{
                                this.setState({
                                    errorBack:''
                                })
                            }
                            
                            /////check data for task part
                            if(this.state.level=='1'|| this.state.level=='2'||this.state.level=='3'){
                                var emptyTask=true;
                                const Taskdata = this.state.task;
                            
                                if(Taskdata !== ''){
                                    emptyTask=false
                                }
                                if(emptyTask==true){
                                    this.setState({
                                        errorTask:'Please enter required task for the module'
                                    })
                                }
                                else{
                                    this.setState({
                                        errorTask:''
                                    })
                                }
                            }
    
                            //////Check data for materials and method
    
                            if(this.state.level=='1'|| this.state.level=='2'){
                                var emptyMat=true;
                                var emptyMet=true;
    
                                const Materialdata = this.state.material;
                                const Methoddata = this.state.method;
                                
                                if(Materialdata !== ''){
                                    emptyMat=false
                                }
                                if(emptyMat==true){
                                    this.setState({
                                        errorMaterial:'Please enter required Material for the module'
                                    })
                                }
                                else{
                                    this.setState({
                                        errorMaterial:''
                                    })
                                }
                            
                                if(Methoddata !== ''){
                                    emptyMet=false
                                }
                                if(emptyMet==true){
                                    this.setState({
                                        errorMethod:'Please enter required Method for the module'
                                    })
                                }
                                else{
                                    this.setState({
                                        errorMethod:''
                                    })
                                }
                            }
    
                            //////Check data for analysis
                            if(this.state.level=='1'){
                                var emptyAnalysis=true;
                                const Analysisdata = this.state.analysis;
                            
                                if(Analysisdata !== ''){
                                    emptyAnalysis=false
                                }
                                if(emptyAnalysis==true){
                                    this.setState({
                                        errorAnalysis:'Please enter Analysis for the module'
                                    })
                                }
                                else{
                                    this.setState({
                                        errorAnalysis:''
                                    })
                                }
                            }
    
                            if(this.state.level=='1'){
                                if(emptyIntro===false && emptyBack===false && emptyTask===false && emptyMat===false
                                    && emptyMet===false&& emptyAnalysis===false){
                                        empty=false
                                }
                                else{
                                    empty=true;
                                }
                                
                            }
                            else if(this.state.level=='2'){
                                if(emptyIntro===false && emptyBack===false && emptyTask===false && emptyMat===false
                                    && emptyMet===false){
                                        empty=false
                                }
                                else{
                                    empty=true;
                                }
                            }
                            else if(this.state.level=='3'){
                                if(emptyIntro===false && emptyBack===false && emptyTask===false){
                                        empty=false
                                }
                                else{
                                    empty=true;
                                }
                            }
                            else if(this.state.level=='4'){
                                if(emptyIntro===false && emptyBack===false){
                                        empty=false
                                }
                                else{
                                    empty=true;
                                }
                            }
                        values.modimage=this.state.modimage
                        values.simulation= this.state.simulation;
                        values.intro_image = this.state.intro_image;
                        values.youtube = this.state.youtube;
                        values.backGroundYou=this.state.backGroundYou;
                        values.materialYou=this.state.materialYou;
                        values.methodYou=this.state.methodYou;
                        values.analysisYou=this.state.analysisYou;
                        values.backGroundImage=this.state.backGroundImage;
                        values.materialImage=this.state.materialImage;
                        values.methodImage=this.state.methodImage;
                        values.analysisImage=this.state.analysisImage;
                        values.analysis=this.state.analysis;
                        values.material=this.state.material;
                        values.method=this.state.method;
                        values.task=this.state.task;
                        values.intro=this.state.intro;
                        values.backGround=this.state.backGround;
                        values.simulation_name=this.state.simulation_name;
                        //alert(JSON.stringify(values, null, 2));
                        if(empty===false){

                        const moduleDetails = {
                            name: values.title,
                            image:values.modimage,
                            youtube:values.youtube,
                            language:values.language,
                            level:this.state.level,
                            topic:this.state.topic,
                            subject:values.subject,
                            std:values.std,
                            description:values.description,
                            simulation_name:values.simulation_name,
                            simulation:values.simulation,
                            intro_image:values.intro_image,
                            intro:values.intro,
                            backGround:values.backGround,
                            backGroundYou:values.backGroundYou,
                            backGroundImage:values.backGroundImage,
                            task:values.task,
                            material:values.material,
                            materialYou:values.materialYou,
                            materialImage:values.materialImage,
                            method:values.method,
                            methodYou:values.methodYou,
                            methodImage:values.methodImage,
                            analysis:values.analysis,
                            analysisYou:values.analysisYou,
                            analysisImage:values.analysisImage
                        }
                        
                        console.log(moduleDetails)   

                            axios.put(`http://localhost:5000/modules/${this.state.id}`, moduleDetails)
                            .then(res => 
                                {
                                    console.log(res.data)   
                                });
                            
                            }
                        }
                        
                    }, 500);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors, values}) => (
                        <Form>
                       
                        {/* <Grid container>
                            <Card>
                                <CardHeader color="primary">
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={9}>
                                        <h4 className={classes.cardTitleWhite}>Update basic details</h4>
                                        </GridItem>
                                       
                                    </GridContainer>
                                    
                                </CardHeader> 
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel1'} onChange={this.handleAccordionChange('panel1')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Basic Details</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Basic details of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Title"
                                            name="title"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Language"
                                            name="language"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            />
                                        </GridItem>
                                        {this.state.isLoading!== true?
                                        <GridItem xs={12} sm={12} md={3}>
                                          
                                          <CreatableSelect
                                                isMulti
                                                onChange={this.handleChange}
                                                options={this.state.module}
                                                defaultValue={this.state.topic}
                                                placeholder="Select or create Topic"
                                                {...this.state.edit!==true ? {isDisabled:true} : {isDisabled:false}}

                                            />
                                            <p>{this.state.errorTopic}</p>
                                            <p>To create new topic-type and press enter</p>

                                        </GridItem>:null}
                                        <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Brief Description"
                                            name="description"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            fullWidth= {true} 
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="level"
                                            label="Level"
                                            value={this.state.level}
                                            onChange={this.handlelevelChange}
                                            select
                                            variant="standard"
                                            helperText="Please select level of module"
                                            margin="normal"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {levelmod.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="subject"
                                            label="Subject"
                                            select
                                            variant="standard"
                                            helperText="Please select the subject"
                                            margin="normal"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {subject.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>

                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="std"
                                            label="std"
                                            select
                                            variant="standard"
                                            helperText="Please select"
                                            margin="normal"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {standard.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <p>Upload image for module</p>
                                        <label htmlFor="modimage">
                                            <input
                                            accept="image/*"
                                            id="modimage"
                                            //multiple
                                            type="file"
                                            name="modimage"
                                            style={{ display: "none" }}
                                            label="Upload image here"
                                            onChange={this.handleUploadClick}
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            />
                                                <Fab color="secondary" aria-label="add" 
                                                    variant="extended"
                                                    size="medium"
                                                    component="span">
                                                    <InsertPhotoIcon /> Add Image
                                                </Fab>
                                            </label>
                                            {this.state.file!=='' ?this.state.uploadSuccess!==true?
                                            <div>
                                            <Button color="success" onClick={this.uploadbutton}>
                                                upload 
                                            </Button>
                                            <Button color="danger" onClick={this.cancelbutton}>
                                                cancel 
                                            </Button></div>:<p>
                                                uploaded successfully
                                            </p>:null}
                                            {this.state.file===''?this.state.modimage.substring(0, 6)!=='assets'?
                                            <img src={mongoUrl+this.state.modimage} style={previewStyle}/>
                                            :<img src={baseUrl+this.state.modimage} style={previewStyle}/>
                                            :<img src={this.state.url} style={previewStyle}/>}
                                        </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                    </Accordion>
                                </CardBody>
                            </Card>
                            

                            <Card>
                                <CardHeader color="primary">
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={9}>
                                        <h4 className={classes.cardTitleWhite}>Update Introduction part</h4>
                                        </GridItem>
                                       
                                    </GridContainer>                                
                                </CardHeader>
                                <CardBody>
                                    <Accordion expanded={this.state.expanded === 'panel2'} onChange={this.handleAccordionChange('panel2')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2bh-content"
                                            id="panel2bh-header"
                                        >
                                            <Typography className={classes.heading}>Introduction part</Typography>
                                            <Typography className={classes.secondaryHeading}>
                                                This tab contains Introduction part of the module
                                            </Typography>
                                        </AccordionSummary>
                                    <AccordionDetails>
                                <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <Field
                                                    component={TextField}
                                                    value={this.state.youtube}
                                                    type="text"
                                                    label="Enter youtube shared link"
                                                    name="youtube"
                                                    onChange={this.handlevideo}
                                                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                    />
                                                    {this.state.youtube!==''? typeof this.state.youtube!=='undefined'? 
                                                     <iframe src={this.state.youtube}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> :null: <p>Please enter correct link</p>}
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload image for Hypothesis part</p>
                                                    <label htmlFor="intro_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        // className={classes.input}
                                                        id="intro_image"
                                                        multiple
                                                        type="file"
                                                        name="intro_image"
                                                        label="Upload image here"
                                                        onChange={this.handleImageUploadClick}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.imagefile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                    <Button color="success" onClick={this.uploadimagebutton}>
                                                        upload 
                                                    </Button>
                                                    <Button color="danger" onClick={this.cancelImagebutton}>
                                                        cancel 
                                                    </Button></div>:<p>
                                                        Pdf updated successfully
                                                    </p>:null}
                                                    {this.state.intro_image!==''&& this.state.imageurl===''?<iframe src={mongoUrl+this.state.intro_image} width="300px" height="400px"></iframe>:
                                                    null}
                                                    {this.state.imageurl!==''?<iframe src={this.state.imageurl} width="300px" height="400px"></iframe>:
                                                    null}

                                                </GridItem>
                                                                                               
                                            </GridContainer>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                               
                                                 <CKEditor
                                                            required
                                                            editor={ ClassicEditor }
                                                            data={this.state.intro}
                                                            config={custom_config}
                                                            onReady={ editor => {
                                                                // You can store the "editor" and use when it is needed.
                                                                console.log( 'Editor is ready to use!', editor );
                                                            } }
                                                            onChange={(event, editor)=>this.onEditorStateChange(event, editor)}
                                                            onBlur={ ( event, editor ) => {
                                                                //console.log( 'Blur.', editor );
                                                            } }
                                                            onFocus={ ( event, editor ) => {
                                                                //console.log( 'Focus.', editor );
                                                            } }
                                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                            />
                                                </GridItem> 
                                            </GridContainer>
                                        </GridItem>
                                        {console.log(this.state.simulation_name)}
                                            <GridItem xs={12} sm={12} md={6}>
                                                {this.state.simulation_name!=='' || this.state.simfile!==''?
                                                    <Field
                                                    component={TextField}
                                                    type="text"
                                                    label="Enter simulation name"
                                                    name="simulation_name"
                                                    value={this.state.simulation_name}
                                                    onChange={this.handleSimNameChange}
                                                    validate={this.validateSimName}
                                                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                    //fullWidth= {true} 
                                                    />
                                                    :null}
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload Simulation for module</p>
                                                    <label htmlFor="modsimulation">
                                                        <input
                                                        accept="application/ggb"
                                                        style={{ display: "none" }}
                                                        id="modsimulation"
                                                        multiple
                                                        type="file"
                                                        name="modsimulation"
                                                        label="Upload simulation here"
                                                        onChange={this.handleSimUploadClick}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <AttachFileIcon /> Add Simulation
                                                        </Fab>
                                                    </label>
                                                    {this.state.simfile!=='' ?this.state.uploadSimSuccess!==true?
                                                    <div>
                                                    <Button color="success" onClick={this.uploadsimbutton}>
                                                        Upload Simulation 
                                                    </Button>
                                                    <Button color="danger" onClick={this.cancelSimbutton}>
                                                        cancel 
                                                    </Button></div>:<p>
                                                        uploaded successfully(It may take some time to load/you can see it in view module page)
                                                    </p>:null}
                                                    {typeof window.GGBApplet !== 'undefined'? 
                                                    this.state.simulation !== ''?
                                                    this.htmlPage():null:null}
                                        </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                    </Accordion>
                                    <p>{this.state.errorIntro}</p>                                               
                                </CardBody>
                            </Card>
                            
                {this.state.level === '1'|| this.state.level === '2' || this.state.level === '3'? 

                            <Card>
                                <CardHeader color="primary">
                                <GridContainer>
                                        <GridItem xs={12} sm={12} md={9}>
                                        <h4 className={classes.cardTitleWhite}>Update Task part</h4>
                                        </GridItem>
                                        
                                    </GridContainer>                                
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel3'} onChange={this.handleAccordionChange('panel3')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Task</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Task part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.task}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorTaskStateChange(event, editor)}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                                    />
                                        <p>{this.state.errorTask}</p>
                                    </GridItem>
                                </GridContainer>
                                </AccordionDetails>
                                </Accordion>
                                </CardBody>
                            </Card>:null}
                            
                            <Card>
                                <CardHeader color="primary">
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={9}>
                                        <h4 className={classes.cardTitleWhite}>Update BackGround part</h4>
                                        </GridItem>
                                        
                                    </GridContainer>                                
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel4'} onChange={this.handleAccordionChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>BackGround</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Background of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                <p>Youtube video for Background part</p>
                                                    <Field
                                                        component={TextField}
                                                        value={this.state.backGroundYou}
                                                        type="text"
                                                        label="Enter youtube shared link"
                                                        name="youtube"
                                                        onChange={this.handleBackvideo}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                    />
                                                        {this.state.backGroundYou!==''? typeof this.state.backGroundYou!=='undefined'? 
                                                        <iframe src={this.state.backGroundYou}
                                                        allow='autoplay; encrypted-media'
                                                        allowFullScreen={true}
                                                        title='video'
                                                        /> :null:<p>Please enter correct link</p>}
                                                    </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload image for BackGround part</p>
                                                    <label htmlFor="back_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        id="back_image"
                                                        multiple
                                                        type="file"
                                                        name="back_image"
                                                        label="Upload image here"
                                                        onChange={this.handleBackUploadClick}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.backfile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                    <Button color="success" onClick={this.uploadimageBackbutton}>
                                                        upload 
                                                    </Button><Button color="danger" onClick={this.cancelBackGroundbutton}>
                                                        cancel 
                                                    </Button></div>:<p>
                                                        Pdf updated successfully
                                                    </p>:null}
                                                    {this.state.backGroundImage!==''&& this.state.backurl===''?<iframe src={mongoUrl+this.state.backGroundImage} width="300px" height="400px"></iframe>:
                                                    null}
                                                    {this.state.backurl!==''?<iframe src={this.state.backurl} width="300px" height="400px"></iframe>:
                                                    null}

                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                                <GridItem xs={12} sm={12} md={8}>
                                                   
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.backGround}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorBackGroundStateChange(event, editor)}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}} 
                                                    />
                                                </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                    </Accordion>
                                </CardBody>
                                <p>{this.state.errorBack}</p>

                            </Card>

                              {this.state.level === '1'|| this.state.level === '2' ?

                            <Card>
                                <CardHeader color="primary">
                                <GridContainer>
                                        <GridItem xs={12} sm={12} md={9}>
                                        <h4 className={classes.cardTitleWhite}>Update Material part</h4>
                                        </GridItem>
                                       
                                    </GridContainer>                                
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel4'} onChange={this.handleAccordionChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Material</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Material part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                <GridContainer>                          
                                    <GridItem xs={12} sm={12} md={4}>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>Youtube video for Material part</p>
                                                    <Field
                                                        component={TextField}
                                                        value={this.state.materialYou}
                                                        type="text"
                                                        label="Enter youtube shared link"
                                                        name="youtube"
                                                        onChange={this.handleMaterialvideo}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        {this.state.materialYou!==''?typeof this.state.materialYou!=='undefined'? 
                                                        <iframe src={this.state.materialYou}
                                                        allow='autoplay; encrypted-media'
                                                        allowFullScreen={true}
                                                        title='video'
                                                        /> :null: <p>Please enter correct link</p>}
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload image for Material part</p>
                                                    <label htmlFor="mat_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        // className={classes.input}
                                                        id="mat_image"
                                                        multiple
                                                        type="file"
                                                        name="mat_image"
                                                        label="Upload image here"
                                                        onChange={this.handleMaterialUploadClick}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.matfile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                    <Button color="success" onClick={this.uploadimageMaterialbutton}>
                                                        upload 
                                                    </Button>
                                                    <Button color="danger" onClick={this.cancelMaterialbutton}>
                                                        cancel 
                                                    </Button></div>:<p>
                                                        pdf updated successfully
                                                    </p>:null}
                                                    {this.state.materialImage!==''&& this.state.maturl===''?<iframe src={mongoUrl+this.state.materialImage} width="300px" height="400px"></iframe>:
                                                    null}
                                                    {this.state.maturl!==''?<iframe src={this.state.maturl} width="300px" height="400px"></iframe>:
                                                    null}

                                                </GridItem>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>

                                                        <CKEditor
                                                            required
                                                            editor={ ClassicEditor }
                                                            data={this.state.material}
                                                            config={custom_config}
                                                            onReady={ editor => {
                                                                // You can store the "editor" and use when it is needed.
                                                                console.log( 'Editor is ready to use!', editor );
                                                            } }
                                                            onChange={(event, editor)=>this.onEditorMaterialStateChange(event, editor)}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                                        />

                                        </GridItem>
                                </GridContainer>
                                </AccordionDetails>
                                </Accordion>
                                <p>{this.state.errorMaterial}</p>
                                </CardBody>
                            </Card>:null}
                            {this.state.level === '1'|| this.state.level === '2' ?

                                <Card>
                                    <CardHeader color="primary">
                                    <GridContainer>
                                            <GridItem xs={12} sm={12} md={9}>
                                            <h4 className={classes.cardTitleWhite}>Update Method part</h4>
                                            </GridItem>
                                        
                                        </GridContainer>                                
                                    </CardHeader>
                                    <CardBody>
                                    <Accordion expanded={this.state.expanded === 'panel5'} onChange={this.handleAccordionChange('panel5')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Method</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Method part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>                          
                                        <GridItem xs={12} sm={12} md={4}>
                                                 <GridItem xs={12} sm={12} md={12}>
                                                 <p>Youtube video for Method part</p>

                                                    <Field
                                                        component={TextField}
                                                        value={this.state.methodYou}
                                                        type="text"
                                                        label="Enter youtube shared link"
                                                        name="youtube"
                                                        onChange={this.handleMethodvideo}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                    />
                                                    {this.state.methodYou!==''? typeof this.state.methodYou!=='undefined'? 
                                                         <iframe src={this.state.methodYou}
                                                        allow='autoplay; encrypted-media'
                                                        allowFullScreen={true}
                                                        title='video'
                                                        /> :null: <p>Please enter correct link</p>}
                                                    </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload image for Method part</p>
                                                    <label htmlFor="method_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        id="method_image"
                                                        multiple
                                                        type="file"
                                                        name="method_image"
                                                        label="Upload image here"
                                                        onChange={this.handleMethodUploadClick}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.methodfile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                    <Button color="success" onClick={this.uploadimageMethodbutton}>
                                                        upload 
                                                    </Button>
                                                    <Button color="danger" onClick={this.cancelMethodbutton}>
                                                        cancel 
                                                    </Button></div>:<p>
                                                        Pdf updated successfully
                                                    </p>:null}
                                                    {this.state.methodImage!==''&& this.state.methodurl===''?<iframe src={mongoUrl+this.state.methodImage} width="300px" height="400px"></iframe>:
                                                    null}
                                                    {this.state.methodurl!==''?<iframe src={this.state.methodurl} width="300px" height="400px"></iframe>:
                                                    null}
                                                </GridItem>     
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={8}>
                                                
                                                 <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.method}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorMethodStateChange(event, editor)}
                                                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                                    />

                                        </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                    </Accordion>
                                    <p>{this.state.errorMethod}</p>
                                    </CardBody>
                                </Card>:null}

                        {this.state.level === '1'?
                            <Card>
                                <CardHeader color="primary">
                                <GridContainer>
                                        <GridItem xs={12} sm={12} md={9}>
                                        <h4 className={classes.cardTitleWhite}>Update Analysis part</h4>
                                        </GridItem>
                                    </GridContainer>                                
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel6'} onChange={this.handleAccordionChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Analysis</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Analysis part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>Youtube video for Analysis part</p>
                                                    <Field
                                                        component={TextField}
                                                        value={this.state.analysisYou}
                                                        type="text"
                                                        label="Enter youtube shared link"
                                                        name="youtube"
                                                        onChange={this.handleAnalysisvideo}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        {this.state.analysisYou!=='' ? typeof this.state.analysisYou!=='undefined'?
                                                        <iframe src={this.state.analysisYou}
                                                        allow='autoplay; encrypted-media'
                                                        allowFullScreen={true}
                                                        title='video'
                                                        />:null: <p>Please enter correct link</p>}
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                    <p>Image for Analysis part</p>
                                                    <label htmlFor="analysis_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        // className={classes.input}
                                                        id="analysis_image"
                                                        multiple
                                                        type="file"
                                                        name="analysis_image"
                                                        label="Upload image here"
                                                        onChange={this.handleAnalysisUploadClick}
                                                        {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.analysisfile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                        <Button color="success" onClick={this.uploadimageAnalysisbutton}>
                                                            upload 
                                                        </Button>
                                                        <Button color="danger" onClick={this.cancelAnalysisbutton}>
                                                            cancel 
                                                        </Button>
                                                    </div>:<p>
                                                        Pdf updated successfully
                                                    </p>:null}
                                                    {this.state.analysisImage!==''&& this.state.analysisurl===''?<iframe src={mongoUrl+this.state.analysisImage} width="300px" height="400px"></iframe>:
                                                    null}
                                                    {this.state.analysisurl!==''?<iframe src={this.state.analysisurl} width="300px" height="400px"></iframe>:
                                                    null}

                                            </GridItem>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                               
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.analysis}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorAnalysisStateChange(event, editor)}
                                                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                                    />

                                        </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                    </Accordion>
                                    <p>{this.state.errorAnalysis}</p>

                                </CardBody>
                            </Card>:null}

                            {isSubmitting && <LinearProgress />}
                            {console.log(isSubmitting)}

                            <GridItem xs={12}>
                                
                                {this.state.edit === true ? 
                                <Button color="primary" onClick={submitForm} disabled={isSubmitting}> 
                                    Update Details
                                </Button> :
                                <Button color="primary" onClick={this.editbutton}>
                                    Edit Details
                                </Button> }
                            </GridItem>
                        </Grid> */}
                        </Form>
                    )}
                </Formik>:null}
        </GridContainer>
      );

  }
}

  export default withRouterCompat(EditForm);